module.exports = __webpack_public_path__ + "static/media/user-guide.7e234946.png";